import { Component } from '../../../../component-decorator';

@Component({
  componentName: 'appAtendimentoFiltro',
  bindings: {
    filter: '<',
    updateFilter: '&',
    clearFilter: '&'
  },
  template: require('./filtro.component.html')
})
export class AtendimentoFiltroComponent implements angular.IController {
  public filter: any = {};
  public clearFilter: (data: any) => void = () => {};
  public updateFilter: (data: any) => void = () => {};

  public clear(evt: any) {
    this.filter.text.options.isText = null;
    this.clearFilter({ $event: evt });
  }

  public send() {
    const key = this.filter.select.isSelected.name;
    const value = this.filter.text.options.isText;

    const filter = {};
    filter[key] = value;
    this.updateFilter({$event: filter});
  }
}
